var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HotelMealBook',{attrs:{"turn":_vm.turn,"mealOrders":_vm.normalOrders,"bookPeople":_vm.bookPeople,"books":_vm.books,"hotel":_vm.hotel}})
}
var staticRenderFns = []

export { render, staticRenderFns }